export default __webpack_public_path__ + "static/media/1988.8d29df6d.jpg";